import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MicroServiceService } from '../services/micro-service.service';

@Component({
  selector: 'app-micro-service-list',
  templateUrl: './micro-service-list.component.html',
  styleUrls: ['./micro-service-list.component.css']
})
export class MicroServiceListComponent {

  microservices: any[] = [];
  originalMicroservices: any[] = [];

  constructor(
    private microServiceService: MicroServiceService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.loadMicroServices();
  }

  // -----------------------------------------------------
  // Load all microservices (permissions-based response)
  // -----------------------------------------------------
  loadMicroServices(): void {
    this.microServiceService.getMicroServices().subscribe({
      next: (res: any) => {

        // 🔐 Normalize response (array OR single object)
        const list = Array.isArray(res) ? res : [res];

        // ✅ Sort by permissions count (DESC)
        this.microservices = [...list].sort(
          (a, b) => (b.count || 0) - (a.count || 0)
        );

        this.originalMicroservices = [...this.microservices];
      },
      error: (err) => console.error('Failed to load microservices', err)
    });
  }

  // -----------------------------------------------------
  // View Microservice Details
  // -----------------------------------------------------
  viewMicroservice(serviceName: string): void {
    this.router.navigate(['/microservices', serviceName]);
  }
}
